export default __webpack_public_path__ + "static/media/translationsSidebarIcon.0f2fe25f.svg";